<div class="container-why">
  <app-navbar></app-navbar>

  <app-overlay-section></app-overlay-section>

  <!-- why huiospay -->
  <div class="why-huiospay">
    <div class="why-left" data-aos="fade-up-right" data-aos-duration="2000">
      <div class="why-title">
        <h2>Why <span style="color: #2E75B3"> HuiosPay? </span></h2>
      </div>
      <div class="why-text">
        <h3>
          No matter the business type (SMEs, MSEs, Startups, etc) or individual transactions,
          our financial vision is jealously focused and inclusive of all business in both the rural and urban
          communities, in Nigeria and beyond.
        </h3>
      </div>
      <div class="why-bulletin">
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Accessibility and wide coverage.</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Reliable security infrastructure.</p>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Modern financial technology to help business growth.</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Fast & easy integrations.</p>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon">
            </div>
            <div class="text">
              <p>Effective customer support & service.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="why-right" data-aos="fade-up-left" data-aos-duration="2000">
      <img src="../../../../assets/img/phoneKey.png" alt="terminal-lock">
    </div>

  </div>
  <!-- end of why huiospay-->

  <!-- our solution-->
  <div class="our-solution" >
    <div class="our-left" data-aos="fade-up-right" data-aos-duration="2000">
      <img src="../../../../assets/img/chart.png" alt="terminal">
    </div>
    <div class="our-right" data-aos="fade-up-left" data-aos-duration="2000">
      <div class="our-title">
        <h2>
          Our solutions are simple,
          intuitive, modern and
          interactive.
        </h2>
      </div>
      <div class="our-text">
        <h3>
          Our financial product infrastructure is tailored at providing simple, modern interactive solutions to give our
          users the best possible business experience.
          We are simply offering impactful solutions with no boundaries, above and beyond.
        </h3>
      </div>

    </div>
  </div>
  <!-- End of our solution-->

  <!-- Community section-->
  <app-community-section></app-community-section>
  <!--End Community section-->

  <!-- footer -->
  <app-footer></app-footer>
  <!-- end of footer -->

</div>

<app-back-to-top [acceleration]="2" [animate]="true" [scrollDistance]="50" [speed]="50">
</app-back-to-top>